import { render } from "./MvFv.vue?vue&type=template&id=03b22ce0"
import script from "./MvFv.vue?vue&type=script&lang=js"
export * from "./MvFv.vue?vue&type=script&lang=js"

import exportComponent from "/Users/kadowakikiyomi/Documents/PEARLY_GATES/CATALOGUE/PG/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__